import { ApolloLink } from '@provision/graphql-client';
import { config } from 'src/core/config';
import { Records } from 'src/graphql/types';
import useSnackbarStore from 'src/store/snackbar';
import useUserActivityStore from 'src/store/user-activity';

export const versionLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(
    (response: { data?: Record<string, Records<unknown>> | null }) => {
      if (!response?.data) {
        return response;
      }

      const data = Object.values(response?.data)[0];
      const { forceAppVersion, appVersion } = data?.metadata ?? {};

      const { showSnackbar } = useSnackbarStore.getState();

      const { isIdle, forceReloadedVersion, setForceReloadedVersion } =
        useUserActivityStore.getState();

      if (forceAppVersion && config.appVersion < forceAppVersion) {
        forceReload(forceAppVersion);
      } else if (appVersion && config.appVersion < appVersion) {
        if (isIdle) {
          forceReload(appVersion);
        } else {
          showSnackbar(
            'A new version of the app is available. Please refresh the page to start using it.',
            {
              severity: 'info',
              autoHide: null,
            },
          );
        }
      }

      function forceReload(toVersion: string) {
        if (forceReloadedVersion && forceReloadedVersion >= toVersion) {
          return;
        }

        showSnackbar('A new version of the app is available. Reloading', {
          severity: 'info',
          autoHide: null,
        });
        setForceReloadedVersion(toVersion);
        setTimeout(() => window.location.reload());
      }
      return response;
    },
  );
});
